import React, { Component } from 'react';
import { Show, TabbedShowLayout, Tab, Datagrid, TextField, NumberField, FunctionField, ArrayField, List, ReferenceField, ReferenceManyField, DateField, BooleanField, TopToolbar, RefreshButton, ListButton, GET_ONE, useListContext } from 'react-admin';
import { CamelCaseField, ExpectedDateField } from '../digitalOrders/common';
import { getLocalStorageKey } from '../common/common';
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from '../common/common'
import Modal from 'react-responsive-modal';
import Spinner from '../../src/spinner';
import myDataProvider from '../myRestProvider';
import { useLocation } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';

// const topToolbarStyle = {
//   zIndex: 2,
//   display: 'inline-block',
//   float: 'right',
// };
class ExampleApp extends React.Component {
  constructor(props) {
    super(props);
    this.fetchItem(props.record.retailer_info.id);
    // this.reload = this.reload.bind(this);
    this.state = {
      open: false,
      showloader: true,
      reloadButton: false,
      data: {},
      dateFlag: false
    };
    console.log('permission', props)
    console.log('id is', props.record.retailer_info.id)
  }
  onOpenModal = () => {
    console.log(this.props);
    this.setState({ open: true, reloadButton: false });
    this.fetchItem(this.props.record.retailer_info.id);
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };
  render() {
    const { open } = this.state;
    return (
      <div className="detailsBtn">
        {
          !open ? <p onClick={this.onOpenModal}>Check balance</p>
            :
            <Modal open={open} onClose={this.onCloseModal} center>
              <table>
                <tr>
                  <th>SAP credit area Cd</th>
                  <th>Last SAP update</th>
                  <th>Currency</th>
                  <th>Credit limit</th>
                  <th>Credit exposure SAP</th>
                  <th>Credit exposure LOGON</th>
                  <th>Open credit LOGON</th>
                  <th>Orders not invoiced price</th>
                  <th>Digital order balance</th>
                </tr>
                <tr>
                  <td>{this.state.data.sap_credit_area_cd}</td>
                  <td >{this.state.dateFlag && this.state.data.last_sap_update}</td>
                  <td>{this.state.data.currency}</td>
                  <td>{this.state.data.credit_limit}</td>
                  <td>{this.state.data.credit_exposure_sap}</td>
                  <td>{this.state.data.credit_exposure_logon}</td>
                  <td>{this.state.data.open_credit_logon}</td>
                  <td>{this.state.data.orders_not_invoiced_price}</td>
                  <td>{this.state.data.sap_digital_order_balance}</td>
                </tr>
                <tr className='errorMsg'>
                  <td colSpan="9">{this.state.reloadButton && window.navigator.onLine &&
                    <div>{this.state.data.msgText}</div>
                  }</td>
                </tr>
                <tr>
                  <td className='spinner' colSpan="9"><div className="spinner">
                    {this.state.showloader && window.navigator.onLine &&
                      <Spinner />
                    }
                  </div>
                    {this.state.reloadButton && window.navigator.onLine &&
                      <div className="refresh" >
                        <i onClick={this.reload} className="material-icons">
                          refresh
                       </i>
                      </div>
                    }
                    <div>
                      {!window.navigator.onLine &&
                        <p>It seems that you are offline. Please check your internet connection</p>
                      }
                    </div></td>
                </tr>
              </table>
            </Modal>
        }
      </div >
    );
  }


  // reload() {
  //   this.setState({
  //     reloadButton: false,
  //     showloader: true
  //   }, () => this.fetchItem(this.props.record.retailer_info.id));
  // }

  fetchItem = async (id) => {
    this.setState({ showloader: true, data: {} },
      async () => {
        const json = await myDataProvider(GET_ONE, 'getSapDetails', { id });
        const item = json.data;
        var countryTime = new Date(item.last_sap_update).toLocaleString("en-US");
        console.log('countryTime', countryTime);
        this.setState({
          showloader: false,
          data: {
            ...item,
            last_sap_update: countryTime,
          },
          reloadButton: item.errorMsg === 'Reload',
          dateFlag: countryTime !== 'Invalid Date',
        });
      });
  }
}

class PayerBalance extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      showloader: false,
      payerReloadButton: false,
      data: {},
      last_sap_update: null,
      dateFlag: false
    };

  }

  componentDidMount() {
    this.fetchItem(this.props.id);
  }

  reload = () => {
    this.setState({
      payerReloadButton: false,
      showloader: true
    }, () => this.fetchItem(this.props.id));
  }


  fetchItem = (id) => {
    console.log('fetch console');
    const { state } = this;
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = 'POST';
    options.body = JSON.stringify({ id: id, business_id: this.props.record.business && this.props.record.business.id });

    let item;
    if (!this.props.record.business) {
      this.setState({ payerReloadButton: true, showloader: false })
    }
    if (this.props.record.business) {
      this.setState({ showloader: true })

      fetch(`${apiUrl}/get_payer_balance`, options)
        .then(res => {
          return res.json();
        })
        .then(json => {
          console.log('json>>>>', json);
          item = json.data
          const countryTime = new Date(item.last_sap_update).toLocaleString("en-US");
          if (item) {
            this.setState({ showloader: false })
          }
          this.setState({ data: item })
          this.setState({ last_sap_update: countryTime })
        })
      console.log('items are', item);
    }
    // if (item.errorMsg === 'Reload') {
    //   this.state.reloadButton = true;
    // }

    // if (this.state.last_sap_update !== 'Invalid Date') {
    //   // this.state.last_sap_update = "sd"
    //   this.setState({ dateFlag: true })
    // }
  }
  render() {
    console.log(' this.state.payerReloadButton', this.state.payerReloadButton);
    return (
      <div className="soldToDetails">
        <table>
          <tbody>
            <tr>
            </tr>
            <tr>
              <th>SAP credit area Cd</th>
              <th>Last SAP update</th>
              <th>Currency</th>
              <th>Credit limit</th>
              <th>Credit exposure SAP</th>
              <th>Credit exposure LOGON</th>
              <th>Open credit LOGON</th>
              <th>Orders not invoiced price</th>
              <th>Digital order balance</th>
            </tr>
            <tr>
              <td>{this.state.data.payer_sap_code}</td>
              <td >{this.state.last_sap_update}</td>
              <td>{this.state.data.currency}</td>
              <td>{this.state.data.credit_limit}</td>
              <td>{this.state.data.credit_exposure_sap}</td>
              <td>{this.state.data.credit_exposure_logon}</td>
              <td>{this.state.data.open_credit_logon}</td>
              <td>{this.state.data.orders_not_invoiced_price}</td>
              <td>{this.state.data.sap_digital_order_balance}</td>
            </tr>
            <tr>
              <td className='errorMsg' colSpan="9">{this.state.payerReloadButton && window.navigator.onLine &&
                <div>{this.state.data.errorMsg}</div>
              }</td>
            </tr>
            <tr>
              <td className='spinner' colSpan="9"><div className="spinner">
                {this.state.showloader && window.navigator.onLine &&
                  <Spinner />
                }
              </div>
                {this.state.payerReloadButton && window.navigator.onLine &&
                  <div className="refresh" >
                    <i onClick={this.reload} className="material-icons">
                      refresh
                        </i>
                  </div>
                }
                <div>
                  {!window.navigator.onLine &&
                    <p>It seems that you are offline. Please check your internet connection</p>
                  }
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }

}

const ShowActions = ({ basePath }) => (
  <TopToolbar>
    <RefreshButton />
    <ListButton basePath={basePath} />
  </TopToolbar>
)

const ShowTitle = ({ record }) => {
  return record && <span>Contract {record.contract_number ? `#${record.contract_number}` : ''}</span>;
};

const ContractsShow = ({ permissions, ...props }) => {
  const showAllOrders = getLocalStorageKey('show_all_orders');
  const location = useLocation();
  const pathSplit = location.pathname.split("/");
  const businessIdVal = pathSplit[2];

  const TruckDataGrid = () => {
    const { data, isLoading } = useListContext();

    if (isLoading) return <div>Loading...</div>;

    const firstRecord = data?.[0];
    const truckNumbers = firstRecord?.truck_number ?? [];

    if (!truckNumbers.length) return <div>No truck data available.</div>;

    return (
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><strong>Truck Number</strong></TableCell>
              <TableCell><strong>Truck ID</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {truckNumbers.map((truck, index) => (
              <TableRow key={index}>
                <TableCell>{truck.truck_number}</TableCell>
                <TableCell>{truck.truck_id}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  return (
    <Show actions={<ShowActions permissions={permissions} />} {...props} title={<ShowTitle />}>
      <TabbedShowLayout className="tab-scroll">
        <Tab label="Contract Details" contentClassName="scrollTab">
          <TextField source="contract_number" />
          <TextField source="contract_type" />
          <ReferenceField label="Sold To Name" source="retailer_info.id" reference="businesses" link="show" allowEmpty>
            <TextField source="name" />
          </ReferenceField>

          <TextField source="retailer_info.sap_code" label="Sold To ID" />
          <DateField label="Contract Valid From" source="contract_valid_from" />

          <DateField label="Contract Valid To" source="contract_valid_to" />
          {permissions === 'isSap' &&
            <ExampleApp id={props.id} />
          }
          <TextField source="inco_term" />
          <BooleanField source="status" />
          <DateField label="Created at" source="created_at" />
        </Tab>
        <Tab label="Payers">
          <ReferenceManyField
            label=""
            addLabel={false}
            sort={{ field: 'created_at', order: 'DESC' }}
            reference="sap_contract_payers"
            source="id"
            target="sap_contract_id"
            className="tab-pagination"
          >
            <List actions={false} {...props} filterDefaultValues={{ sap_contract_id: businessIdVal }} exporter={false}>
              <Datagrid expand={<PayerBalance payerDetails={props} />} bulkActionButtons={false}>
                <TextField source="payer_name" />
                <TextField source="payer_sap_code" />
              </Datagrid>
            </List>
          </ReferenceManyField>
        </Tab>
        {/* <Tab label="Payers">
                    <ReferenceManyField
                        addLabel={false}
                        sort={{ field: 'created_at', order: 'DESC' }}
                        reference="sap_contract_payers"
                        source="id"
                        target="sap_contract_id"
                    >
                    <Datagrid rowClick="show">
                                <TextField source="payer_name"/>
                                <TextField source="payer_sap_code"/>
                            </Datagrid>
                    </ReferenceManyField>
                </Tab> */}
        <Tab label="Ship-Tos">
          <ReferenceManyField
            label=""
            addLabel={false}
            sort={{ field: 'created_at', order: 'DESC' }}
            reference="sap_business_sites"
            source="id"
            target="sap_contract_id"
            className="tab-pagination"
          >
            <List actions={false} {...props} filterDefaultValues={{ sap_contract_id: businessIdVal }} exporter={false}>
              <Datagrid rowClick="show" bulkActionButtons={false}>
                <TextField label="Ship To ID" source="ship_to_sap_number" />
                <TextField label="Ship To Name" source="name" allowEmpty />
                <TextField source="phone" sortable={false} allowEmpty />
                <ReferenceField label="Sold To Name" source="business_id" reference="businesses" link="show" allowEmpty>
                  <TextField source="name" />
                </ReferenceField>
                <TextField label="Sold To ID" source="retailer_sapcode" sortable={false} />
                <DateField label="Created at" source="created_at" allowEmpty />
                <TextField source="status" />
              </Datagrid>
            </List>
          </ReferenceManyField>
        </Tab>
        <Tab label="Orders">
          <ReferenceManyField
            label=""
            addLabel={false}
            sort={{ field: 'created_at', order: 'DESC' }}
            reference={showAllOrders ? "sap_digital_orders" : "sap_digital_app_orders"}
            source="id"
            target="sap_contract_id"
            className="tab-pagination"
          >
            <List actions={false} {...props} filterDefaultValues={{ sap_contract_id: businessIdVal }} exporter={false}>
              <Datagrid rowClick="show" bulkActionButtons={false}>
                <DateField label={'Order Date'} source="creation_date" />
                <ReferenceField label="Sold To Name" source="business_id" reference="businesses" link="show" allowEmpty>
                  <TextField source="name" />
                </ReferenceField>
                <TextField source="order_number" />
                <CamelCaseField source="mode_of_delivery" label="Mode Of Delivery" />
                <ExpectedDateField label="Expected Date" source="delivery_date_from" />
                <TextField label="Local PO / Note" source="customer_ref_number" />
                <TextField label="Order Status" source="customer_order_status_desc" />
                <ReferenceField label="Ship To Name" source="sap_business_site_id" reference="sap_business_sites" link="show" allowEmpty>
                  <TextField source="name" />
                </ReferenceField>
                {
                  permissions === 'isSap' &&
                  <DateField label="Date 1st seen in LR" source="created_at" />
                }
                {
                  permissions === 'isSap' && showAllOrders &&
                  <TextField label="Is App Order" source="is_app_order" />
                }
              </Datagrid>
            </List>
          </ReferenceManyField>
        </Tab>
        <Tab label="Products">
          <ReferenceManyField
            label=""
            addLabel={false}
            sort={{ field: 'created_at', order: 'DESC' }}
            reference="sap_contract_products"
            source="id"
            target="sap_contract_id"
            className="tab-pagination"
          >
            <List actions={false} {...props} filterDefaultValues={{ sap_contract_id: businessIdVal }} exporter={false}>
              <Datagrid bulkActionButtons={false}>
                <TextField source="material_number" />
                <TextField source="material_description" />
                <TextField source="position" />
                {/* <TextField source="plant_code" /> */}
                <TextField label="Plant" source="sap_plant.name" />
                {/* <TextField source="shipping_point" /> */}
                <TextField label="Shipping Point" source="shipping_point_plant.name" />
                <FunctionField
                  label="Truck Numbers"
                  render={(record) =>
                      record?.truck_number
                          ?.map(item => item.truck_number)
                          .join(', ')
                  }
              />
                <NumberField source="net_price" />
                <NumberField label="VAT(%)" source="vat" />
                <NumberField source="price_after_tax" />
              </Datagrid>
            </List>
          </ReferenceManyField>
        </Tab>

        <Tab label="Trucks">
          <ReferenceManyField
            label=""
            addLabel={false}
            sort={{ field: 'created_at', order: 'DESC' }}
            reference="sap_contract_products"
            source="id"
            target="sap_contract_id"
            className="tab-pagination"
          >
            <TruckDataGrid />
          </ReferenceManyField>
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};

export default ContractsShow;